module.exports = __webpack_public_path__ + "static/media/lemon.d7bb7380.svg";